import { Link } from 'react-router-dom';
import TimeAgo from 'components/utils/LocalizedTimeAgo';
import { useDispatch, useSelector } from 'react-redux'
import { acceptRequest, deleteRequest } from '../../../features/requests/requestSlice'
import { imgUrl } from 'features/constants';
import styled from 'styled-components';
import { RequestsItemInfo, ReqReceivedItemContainer, RequstItemName, ReqItemImage, ReqButton } from './reqests.styled';
import { useTranslation } from 'react-i18next'


function ReqSentItem({reqId, churchId, fullName, username, image, about, createdAt}) {
    const { t } = useTranslation('settings')
    const dispatch = useDispatch()
    let date = new Date(createdAt)


    const handleCancel = () => {
        dispatch(deleteRequest({
            type: "cancel",
            reqId: reqId,
            churchId: churchId,
        }))
    }

 

    return (
        <ReqReceivedItemContainer>
            <RequestsItemInfo>
                <ReqItemImage  src={image} alt='Request' /> 
                <RequstItemName> 
                    <div className='reqTooltip'>
                        <Link to={`/${username}`}><span>{fullName}</span></Link>
                        <span className="reqTooltiptext">{t('membership.viewProfile')}</span>
                    </div> 
                </RequstItemName>
            </RequestsItemInfo>

 
            <ReqButton onClick={handleCancel}>
                Cancel
            </ReqButton> 

        </ReqReceivedItemContainer>
    )
}

export default ReqSentItem
